// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__oP2Ya","label":"Completed_label__2333n"};